/*=========================================================================================
  File Name: getters.js
  Description: Vuex Store - getters
  ----------------------------------------------------------------------------------------
==========================================================================================*/

const getters = {};

export default getters;
